import {useSelector} from "react-redux";
import {useEffect, useState} from "react";

const useInstallationOptions = (includeAllValue = false) => {
    // includeAllValue mostly for reports. Having empty value "" means "Όλες"
    const companyInstallations = useSelector((state) => state.COMPANY_DATA.companyInstallations);

    const [installationOptions, setInstallationOptions] = useState([]);

    useEffect(() => {
        if (companyInstallations.length > 0) {
            let options = [];
            if (includeAllValue) options.push({value: "", label: "Όλες"})
            companyInstallations.forEach((inst) => {
                options.push({ value: inst.installationMasterId, label: inst.type + " " + inst.address + " " + inst.city });
            })
            setInstallationOptions(options);
        }
    }, [])

    return installationOptions;
}

export default useInstallationOptions;
